import { Routing } from '../Routes';
import { useApi, Res, fetchResourceMap } from '../../state/api';
import { Main } from '../Main/Main';
import { LoaderPage } from './LoaderPage';
import { ErrorPage } from './ErrorPage';
import { useTranslation } from '../../i18n/i18n';
import { LinkListingFilter } from '../../components/LinkListingFilter/LinkListingFilter';
import { useMemo } from 'react';
import { useQuery } from '../../hooks/useQuery';
import { useConfig } from '../../config';
import { Helmet } from 'react-helmet-async';

export const BrandsPage = (): JSX.Element => {
	const { data: brands, error } = useApi(Res.brands, {});
	const t = useTranslation().brand;
	const urls = useTranslation().routes;
	const query = useQuery();
	const config = useConfig();

	const brandsArr = useMemo(
		() =>
			Object.entries(brands || {})
				.map((brand) => ({
					url: `${urls.brands}/${brand[0]}`,
					name: brand[1],
				}))
				.filter((b) => {
					const letter = query.get('letter');

					if (!letter) return true;
					if (letter === 'other') return !config.alphabet.includes(b.name[0].toUpperCase());
					return b.name[0].toLowerCase() === letter.toLowerCase();
				}),
		[query.toString(), brands?.toString()]
	);

	if (error) return <ErrorPage />;
	if (!brands) return <LoaderPage />;

	return (
		<Main>
			<Helmet>
				<title>{t.brands + t.titleShortSuffix}</title>
			</Helmet>
			<h1>{t.brands}</h1>
			<LinkListingFilter searchLabel={t.searchLabel} links={brandsArr} />
		</Main>
	);
};

export const brandsPageRouting: Routing = {
	path(urls) {
		return urls.brands;
	},
	component: BrandsPage,
	requiresAuth: false,
	preload: async (config) => {
		return fetchResourceMap(config, Res.brands, {});
	},
};
